(function () {
    const _handleScroll = function () {
        // Scroll position from the top
        const scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

        // Get the button
        const button = document.getElementById('bttBtn');

        _toggleButton(scrollTop, button);

        _adjustButtonPosition(button);
    };

    const _toggleButton = (scrollTop, button) => {
        // Started scroll considering btn size
        if (scrollTop > 60) {
            button.classList.add('scrolled');
        } else {
            button.classList.remove('scrolled');
        }
    };

    const _adjustButtonPosition = (button) => {
        // Is bottom of the page minus the footer
        if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight) - 84) {
            button.classList.add('bottom');
        } else {
            button.classList.remove('bottom');
        }
    };

    window.addEventListener('scroll', _handleScroll);
}());
